<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { clearStoragePreserving } from "@/services/storage";

const router = useRouter();
const store = useStore();

const performSignout = async () => {
  try {
    clearStoragePreserving([]);
    await store.dispatch("logout");
    await router.replace({ name: "Signin" });
  } catch (error) {
    console.error("Failed to sign out", error);
  }
};

onMounted(() => {
  performSignout();
});
</script>

<template>
  <div
    class="min-vh-100 d-flex align-items-center justify-content-center text-center"
  >
    <div>
      <div class="mb-3 spinner-border text-success" role="status"></div>
      <p class="mb-0 text-muted">Signing you out...</p>
    </div>
  </div>
</template>
